import env from 'src/env';
import * as Sentry from '@sentry/browser';
import { configUtils } from '../config';

const RollbarMock = {
  /* eslint-disable */
  critical: (critical) => console.error('Rollbar.critical: ', critical),
  error: (errorMessage, error) =>
    console.error('Rollbar.error: ', errorMessage, error),
  warning: (warn) => console.warn('Rollbar.warning: ', warn),
  info: (info) => console.info('Rollbar.info: ', info),
  global: (stuff) => console.log('Rollbar.global: ', stuff),
  configure: (stuff) => console.log('Rollbar.configure: ', stuff),
  /* eslint-enable */
};

/*
 * Send an error to rollbar.
 * If development mode, then use a mock rollbar object.
 * @param {string} errorMessage - description of the error
 * @param {Error} [error] - optional error object
 */
const trackError = (errorMessage, error) => {
  let rollbar = window && window.Rollbar;
  if (!rollbar || configUtils.isDevelopment()) {
    rollbar = RollbarMock;
  }

  if (env.SENTRY_DSN) {
    Sentry.captureException(error);
  }

  return rollbar.error(errorMessage, error);
};

export default trackError;
